<template>
  <div>
    <v-flex-container v-if="state === 2 || state === null" center>
      <div v-text-align.center>
        <v-text type="subheadling" bold> Данные устарели </v-text>
      </div>
    </v-flex-container>
    <v-flex-container v-else center>
      <div v-if="isFetching">
        <v-spinner block v-margin.bottom="1" v-margin.top="1" />
      </div>
      <div v-else v-padding="2" style="max-width: 1024px">
        <div v-margin.bottom="1">
          <v-text type="title" bold>СОГЛАСИЕ </v-text>

          <div>
            <v-text type="subheadling" bold c>
              на получение информации в Бюро кредитных историй и обработку
              персональных данных
            </v-text>
          </div>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Дата оформления согласия
            {{ moment(currentDate).format('DD.MM.YYYY') }} г.
            <br />
            Я, (ФИО) {{ subject.lastName }} {{ subject.fisrtName }}
            {{ subject.maiddleName }}.<br />
            Место рождения {{ subject.placeBirth }}.<br />
            Дата рождения {{ moment(subject.birthDate).format('DD.MM.YYYY') }} г.,
            Паспорт серия {{ subject.documentSeries }} №{{
              subject.documentNumber
            }}. <br />
            Паспорт выдан {{ moment(subject.issueDate).format('DD.MM.YYYY') }} г.
            <br />
            настоящим выражаю свое согласие на получение ООО
            «Экспертбизнесконсалтинг» (далее: «Оператор», «ООО «ЭБК») из любого
            бюро кредитных историй кредитного отчета, содержащего, в том числе,
            основную часть кредитной истории, в объеме и порядке,
            предусмотренном Федеральным законом от 30.12.2004г. № 218-ФЗ «О
            кредитных историях», в целях получения сведений, содержащихся в
            основной части кредитной истории, для оценки кредитоспособности
            субъекта и предоставления указанных сведений в
            «{{ requester.companyName }}» ИНН:{{ requester.inn }} (наименование
            получателя). Настоящее согласие действительно с момента его
            оформления и считается действительным в течение шести месяцев.
          </v-text>
        </div>

        <div v-margin.bottom="1">
          <v-text>
            <strong>
              Обработка данных осуществляется в информационной системе «Exbico
              2.0», принадлежащей ООО «ЭБК».</strong
            >
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Согласие на обработку персональных данных дается мною в целях
            получения услуг, оказываемых Оператором, для проверки
            кредитоспособности, своевременности выполнения мной кредитных
            обязательств перед кредитными организациями для оценки моей
            благонадежности «{{ requester.companyName }}»
            ИНН:{{ requester.inn }}(наименования получателя). В соответствии с
            Федеральным законом от 27.07.2006г. № 152-ФЗ «О персональных
            данных», я даю согласие Оператору на обработку моих персональных
            данных (фамилия, имя, отчество, год, месяц, дата и место рождения;
            адрес, номер паспорта и сведения о дате выдачи паспорта и выдавшем
            его органе; образование, профессия, место работы и должность;
            домашний, рабочий и мобильный телефоны, адрес электронной почты,
            сведения из кредитной истории и т.д.)
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Я проинформирован(а), что под обработкой персональных данных
            понимаются действия (операции) с персональными данными в рамках
            Федерального закона №152-ФЗ от 27.07.2006 г. как с использованием
            средств автоматизации, так и без использования таковых и включает в
            себя сбор, систематизацию, накопление, хранение, уточнение
            (обновление, изменение), использование, предоставление,
            обезличивание, блокирование, уничтожение персональных данных,
            передача персональных данных «{{ requester.companyName }}»
            ИНН:{{ requester.inn }} (наименование получателя). Конфиденциальность
            персональных данных соблюдается Оператором в рамках законодательства
            Российской Федерации. Передача персональных данных третьим лицам,
            которым Оператор передает соответствующие персональные данные для
            достижения указанных выше целей, производится Оператором при
            обязательном условии обеспечения данными лицами безопасности
            предоставленных выше персональных данных.
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Я выражаю согласие на направление на мой номер телефона, указанный в
            Согласиях, СМС-сообщений и/или звонков с информацией рекламного
            характера об услугах Оператора, партнеров Оператора.
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Согласие действует бессрочно и прекращается при наступлении одного
            из следующих событий: отзыв согласия на обработку персональных
            данных или достижение цели обработки персональных данных.
          </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text>
            Я оставляю за собой право отозвать свое согласие посредством
            составления соответствующего письменного документа, который может
            быть направлен мной в адрес Оператора по электронной почте:
            <v-link target="_blank" to="mailto:support@unirate24.ru">
              support@unirate24.ru
            </v-link>
            или заказным письмом с уведомлением о вручении по адресу: 620041, г.
            Екатеринбург, ул. Красина 7, а/я 28.
          </v-text>
        </div>

        <div v-if="showForm && state === 0">
          <v-form
            ref="form"
            :validate="validateForm"
            @submit="handleSubmit"
            :readonly="false"
          >
            <template scope="api">
              <form-phone-verify
                @send-code="handleSendCode(api.getValue('phone'))"
                @confirm-code="handleConfirmCode(api.getValues())"
                @reset="handleReset(api)"
                :disabled="false"
                :loader="false"
                :invalidCode="!!api.getError('smscode')"
                :invalidPhone="!!api.getError('phone')"
                v-margin.bottom="2"
              />
              <v-row justifyContent="between">
                <v-col xs="5">
                  <v-button
                    :disabled="disabled || isSending"
                    @click="() => (accept = true)"
                    type="submit"
                    primary
                    block
                  >
                    Подтверждаю
                  </v-button>
                </v-col>
                <v-col xs="5">
                  <v-button
                    type="submit"
                    :disabled="isSending"
                    block
                    @click="() => (accept = false)"
                  >
                    Не Подтверждаю
                  </v-button>
                  <div v-margin.bottom="1" v-margin.top="2">
                    <v-text type="subheadling">
                      Пожалуйста укажите причину
                    </v-text>
                  </div>

                  <div v-margin.bottom="2">
                    <v-form-radio
                      v-margin.bottom="2"
                      field="declineReason"
                      :data="0"
                      label="Я не понимаю о чем речь"
                    />
                    <v-form-radio
                      v-margin.bottom="2"
                      field="declineReason"
                      :data="1"
                      label="Я не являюсь указанным лицом"
                    />
                    <v-form-radio
                      v-margin.bottom="2"
                      field="declineReason"
                      :data="2"
                      label="Не актуально"
                    />
                  </div>
                </v-col>
              </v-row>

              <div v-margin.bottom="4" v-margin.top="2">
                <div v-if="serverError" v-padding.top="1">
                  <v-text danger>
                    {{ serverError }}
                  </v-text>
                </div>
              </div>
            </template>
          </v-form>
        </div>

        <div v-else v-text-align.center>
          <v-text type="subheadling" bold>
            Согласие было {{decision}}. {{ moment().format('DD.MM.YYYY') }}
          </v-text>
        </div>
      </div>
    </v-flex-container>
  </div>
</template>
<script>
import MobileNaigation from '../sign/MobileNaigation';
import {
  vCard,
  vFlexContainer,
  vButton as vButtonGreen,
} from '../sign/baseComponents';
import FormPhoneVerify from './FormPhoneVerify';
import { validateCRVForm } from './validations';
import { getCRVData, sendCRV } from '../../services/api/crv';
import moment from 'moment';

export default {
  name: 'crv',
  components: {
    vCard,
    FormPhoneVerify,
    vFlexContainer,
    vButtonGreen,
    MobileNaigation,
  },
  data() {
    return {
      disabled: false,
      serverError: undefined,
      accept: undefined,
      currentDate: null,
      showForm: true,
      isFetching: true,
      isSending: false,
      subject: {
        birthDate: null,
        documentNumber: null,
        documentSeries: null,
        fisrtName: null,
        issueDate: null,
        lastName: null,
        maiddleName: null,
        placeBirth: null,
      },
      requester: {
        companyName: null,
        inn: null,
      },
      state: null
    };
  },
  created() {
    getCRVData(this.$route.params.code)
      .then((res) => {
        console.log(res.data);
        this.subject = res.data.subject;
        this.requester = res.data.requester;
        this.currentDate = res.data.currentDate;
        this.state = res.data.state;
        this.isFetching = false;
        this.token = this.$route.params.code;
        this.decision = res.data.state == 1 ? "подтверждено" : "отменено";
      })
      .catch((res) => {
        this.isFetching = false;
      });
  },
  methods: {
    moment,
    validateForm(values) {
      const errors = validateCRVForm(values);
      this.disabled = !!errors;
    },
    handleSubmit(values) {
      this.serverError = undefined;
      const data = {
        isAccepted: this.accept,
        token: this.token,
        declineReason: values.declineReason
      };

      if(this.accept){
        data.code = values.code.replace(/ /gi, '')
      }

      this.isSending = true;
      sendCRV(data)
        .then((res) => {
          this.isSending = false;

          //  if (res. что-то)
          this.showForm = false;
          this.decision = this.accept ? "подтверждено" : "отменено";
        })
        .catch((error) => {
          this.isSending = false;
          this.serverError = error.data.message;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// CRV.vue?629d271d